export default class BundlesCardDataLayer {
	constructor({ bundleInfo }, prodConfig, total) {
		if (window.dataLayer && bundleInfo && prodConfig.data && prodConfig.data.length) {
			this.dataLayer = window.dataLayer;
			this.bundleTitle = bundleInfo.title;
			this.data = prodConfig.data.slice();
			this.currency = prodConfig.currency;
			this.total = total;
			this.bundleItems = [];
			this.addToDataLayer();
		}
	}

	addInitialProducts() {
		let normalizedProducts = this.data.reduce((normalizedDataProducts, dataProduct) => {
			let normalizedProduct = this.normalizeProduct(dataProduct);
			normalizedDataProducts.push(normalizedProduct);
			return normalizedDataProducts;
		}, []);

		return normalizedProducts;
	}

	updateDataLayer() {
		this.data.forEach((dataProduct) => {
			let sku = dataProduct.SKU || dataProduct.sku;
			this.updateCreateProduct(sku, dataProduct);
		});
	}

	updateCreateProduct(sku, dataProduct) {
		let currency = this.currency;
		let bundleTitle = this.bundleTitle;
		let product = this.dataLayer.items.find((product) => product.productInfo['product-sku'] === sku);

		if (product) {
			product.productInfo['product-currency'] = currency;
			product.productInfo['product-price'] = dataProduct.price;
			let bundleTitles = product.productInfo['product-bundle'];
			product.productInfo['product-bundle'] = bundleTitles + '|' + bundleTitle;
		} else {
			let normalizedProduct = this.normalizeProduct(dataProduct);
			this.dataLayer.items.push(normalizedProduct);
		}
	}

	normalizeProduct(dataProduct) {
		let currency = this.currency;
		let bundleTitle = this.bundleTitle;
		let product = {};
		let productInfo = {};
		productInfo['product-sku'] = dataProduct.SKU || dataProduct.sku;
		productInfo['product-name'] = dataProduct.productTitle || dataProduct.productLable;
		productInfo['product-currency'] = currency;
		productInfo['product-price'] = dataProduct.price;
		productInfo['product-bundle'] = bundleTitle;
		product.productInfo = productInfo;
		return product;
	}

	addTotalBundlesNumber() {
		if (!this.dataLayer.totalBundles) {
			this.dataLayer.totalBundles = this.total;
		}
	}

	subtractTotalBundlesNumber() {
		let currentTotal = this.dataLayer.totalBundles;
		let newTotal = currentTotal - 1;
		this.dataLayer.totalBundles = newTotal;
		if (newTotal === 0) {
			delete this.dataLayer.totalBundles;
			console.info('[DataLayer Complete :: Trigger ProductPageLoad]');
			if (window.adobeDataLayer) adobeDataLayer.push({ event: 'productpageload' });
			else console.warn('adobeDataLayer not found');
		}
	}

	addToDataLayer() {
		this.addTotalBundlesNumber();
		if (!this.dataLayer.items || !this.dataLayer.items.length) {
			let normalizedProducts = this.addInitialProducts();
			this.dataLayer.items = normalizedProducts;
		} else {
			this.updateDataLayer();
		}
		this.subtractTotalBundlesNumber();
	}
}
